type PaymentSheetError = {
  code: string;
  message: string;
};

const unavailableError: PaymentSheetError = {
  code: 'PaymentSheetUnavailable',
  message: 'Stripe Payment Sheet is only available in the native app.',
};

export async function initStripe(): Promise<void> {
  throw new Error('PAYMENT_SHEET_UNAVAILABLE');
}

export function useStripe() {
  return {
    initPaymentSheet: async () => ({ error: unavailableError }),
    presentPaymentSheet: async () => ({ error: unavailableError }),
  };
}